<template>
  <v-card class="back" style="height: 800px">
    <v-layout fill-height>
      <v-flex >
        <v-layout column fill-height>
          <scroll-area>
            <template slot="header">
              <v-toolbar dark color="secondary" dense flat>
                <v-toolbar-title>
                  <span class="body-2 text-uppercase">{{ getData.id || '' }}</span>
                </v-toolbar-title>

                <v-layout  justify-end>
                  <v-tooltip v-if="editMode" dark color="secondary" bottom>
                    <v-btn v-if="editMode" icon flat slot="activator" 
                    :data-testid="$options.name + '__btn__' + 'edit'"
                    @click="() => {editMode = !editMode}">
                      <svg-icon
                        :color="'white'"
                        :name="'edit'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('edit') }}</span>
                  </v-tooltip>
                  <v-tooltip v-if="!editMode" dark color="secondary" bottom>
                    <v-btn v-if="!editMode" icon flat slot="activator" 
                    :data-testid="$options.name + '__btn__' + 'save'"
                    @click="">
                      <svg-icon
                        :color="'white'"
                        :name="'done'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('save') }}</span>
                  </v-tooltip>
                  <v-tooltip v-if="editMode" dark color="secondary" bottom>
                    <v-btn v-if="editMode" icon flat slot="activator" 
                    :data-testid="$options.name + '__btn__' + 'close'"
                    @click="()=>{$emit('close')}">
                      <svg-icon
                        :color="'white'"
                        :name="'close'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('close') }}</span>
                  </v-tooltip>
                  <v-tooltip v-if="!editMode" dark color="secondary" bottom>
                    <v-btn v-if="!editMode" icon flat slot="activator" 
                    :data-testid="$options.name + '__btn__' + 'cancel'"
                    @click="() => {editMode = !editMode}">
                      <svg-icon
                        :color="'white'"
                        :name="'close'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('cancel') }}</span>
                  </v-tooltip>
                </v-layout>
              </v-toolbar>             
            </template>

            <template slot="body">
              <v-layout fill-height justify-start class="pa-2">
                <v-layout column fill-height justify-start >

                  <!-- <json-viewer 
                    :value="getData"
                    :expand-depth="5"
                  ></json-viewer> -->

                  <JsonEditorVue
                    v-model="getData"
                    :read-only="editMode"
                    v-bind="{
                      mode: 'tree',
                      mainMenuBar: true,
                      navigationBar: true,
                      statusBar: true,
                      onRenderMenu: handleRenderMenu,
                      onRenderContextMenu: handleRenderContextMenu,
                      onValidate: handleValidate
                    }"
                  />

                </v-layout>
              </v-layout>
            </template>

          </scroll-area>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import JsonViewer from 'vue-json-viewer'
import { ref } from 'vue'
import JsonEditorVue from 'json-editor-vue'
// Импортируем типы элементов меню из vanilla-jsoneditor
import type { MenuItem, ContextMenuItem, ContextMenuProp } from 'vanilla-jsoneditor'

const translations: Record<string, string> = {
  'duplicate': 'Дублировать',
  'insert': 'Вставить',
  'append': 'Добавить в конец',
  'remove': 'Удалить',
  'cut': 'Вырезать',
  'copy': 'Копировать',
  'paste': 'Вставить из буфера',
  'extract': 'Извлечь',
  'sort': 'Сортировать',
  'transform': 'Преобразовать',
  'insert before': 'Вставить до',
  'insert after': 'Вставить после',
  'type': 'Тип',
  'to value': 'В значение',
  'to array': 'В массив',
  'to object': 'В объект',
  'convert to:': 'Конвертировать в:',
  'format': 'Форматировать',
  'compact': 'Сжать',
  'undo': 'Отменить',
  'redo': 'Повторить',
  'tree': 'Дерево',
  'text': 'Текст',
  'table': 'Таблица',
  'edit key': 'Изменить ключ',
  'edit value': 'Изменить значение',
  'edit structure': 'Изменить структуру',
  'edit object': 'Изменить объект',
  'edit array': 'Изменить массив',
  'structure': 'Структура',
  'object': 'Объект',
  'array': 'Массив',
  'value': 'Значение',
  'cut formatted': 'Вырезать отформатированный',
  'cut compacted': 'Вырезать сжатый',
  'copy formatted': 'Копировать отформатированный',
  'copy compacted': 'Копировать сжатый',
  'enforce string': 'Принудительное использование строки',
  "An object cannot be opened in table mode. You can open a nested array instead, or open the\n        document in tree mode.": 'Жопа',
  'force type': 'Принудительный тип'
}

// Типы
interface ModelData {
  fields: Record<string, any>
  obj: Record<string, any>
  pattern: any | null
}

interface DataProps {
  [key: string]: any
}

interface RenderContextMenuProps {
  items: ContextMenuItem[]
  selection: any // Текущее выделение в редакторе
  clickInfo: {
    type: 'row' | 'button' | 'background'
    path: string[]
  }
}

interface ValidationError {
  path: (string | number)[]
  message: string
  severity?: 'warning' | 'error' // Опционально, зависит от версии
  // При необходимости можно расширить полями от Ajv (например, keyword?: string)
}

interface TranslationPattern {
  pattern: RegExp
  replace: string
}


export default Vue.extend({
  name: 'TEMPLATES_CARD',

  components: {
    scrollArea,
    svgIcon,
    JsonViewer,
    JsonEditorVue
  },

  props: {
    data: {
      type: Object as () => DataProps,
      default: () => ({})
    },
  },

  data(): {
    editMode: boolean
    model: ModelData
  } {
    return {
      editMode: true,
      model: {
        fields: {},
        obj: {},
        pattern: null,
      },
    }
  },

  computed: {
    getData(): DataProps {
      return this.data
    },

    getFields(): Record<string, any> {
      return this.model.fields
    },
  },

  watch: {
    data: {
      handler(newVal: DataProps): void {
        console.log('WATCH', 'ZTP', 'tree', newVal)
        if (newVal) {
          this.setup()
        }
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      console.log(this.$options.name, 'setup', 'data', this.data)
      // let i18n = (this as any)._i18n?.messages?.ru
      // console.log('I18N', i18n)
      // let i18n = (this as any)._i18n?.messages?.[(this as any)._i18n?.locale]?.[string]
      this.reset()
    },

    reset(): void {
      this.editMode = true
      this.model = {
        fields: {},
        obj: {},
        pattern: null,
      }
    },

    handleValidate: (json: any): ValidationError[] => {
      // Инициализируем массив для кастомных ошибок, если нужно делать свои проверки
      const customErrors: ValidationError[] = []

      // Словарь паттернов регулярных выражений для перевода
      const errorTranslations: TranslationPattern[] = [
        { pattern: /Unexpected token/i, replace: 'Неожиданный символ в структуре' },
        { pattern: /Expected ',' instead of/i, replace: 'Пропущена запятая или закрывающая кавычка' },
        { pattern: /is required/i, replace: 'обязательное поле для заполнения' },
        { pattern: /must be string/i, replace: 'должно быть строкой' },
        { pattern: /must be number/i, replace: 'должно быть числом' },
        { pattern: /must be boolean/i, replace: 'должно быть логическим типом (true/false)' },
        { pattern: /must be array/i, replace: 'должно быть массивом []' },
        { pattern: /must be object/i, replace: 'должно быть объектом {}' },
        { pattern: /Unexpected end of JSON input/i, replace: 'JSON завершился неожиданно. Проверьте закрывающие скобки } или ]' },
        { pattern: /Duplicate key/i, replace: 'Этот ключ дублируется, имена ключей должны быть уникальными' }
      ]

      // Специфика json-editor-vue: хук onValidate возвращает функцию-модификатор,
      // которая принимает исходный массив ошибок встроенного парсера/схемы
      return (errors: ValidationError[]): ValidationError[] => {
        // Если встроенных ошибок нет и добавлены свои кастомные
        const allErrors = [...errors, ...customErrors]

        return allErrors.map((err: ValidationError): ValidationError => {
          let translatedMessage: string = err.message

          // Поиск совпадения в словаре
          for (const item of errorTranslations) {
            if (item.pattern.test(err.message)) {
              const field = err.path && err.path.length ? `Поле [${err.path.join('.')}] ` : ''
              translatedMessage = `${field}${item.replace}`
              break
            }
          }

          return {
            ...err,
            message: translatedMessage
          }
        })
      }
    },

    handleRenderMenu: (items: MenuItem[]): MenuItem[] => {

      
      return items.map((item: MenuItem) => {
        // Проверяем тип 'space' или аналогичные, у которых нет текста, 
        // чтобы TS не ругался на отсутствие свойств
        if ('text' in item && typeof item.text === 'string') {
          const key = item.text.toLowerCase()
          if (translations[key]) {
            item.text = translations[key]
          }
        }

        if ('title' in item && typeof item.title === 'string') {
          const key = item.title.toLowerCase()
          if (translations[key]) {
            item.title = translations[key]
          }
        }

        // Если это группа меню (например, переключатель режимов)
        if ('items' in item && Array.isArray(item.items)) {
          item.items = handleRenderMenu(item.items)
        }

        return item
      })
    },

    handleRenderContextMenu(items: ContextMenuItem[]): ContextMenuItem[] | void {
      // Безопасная проверка: если items не переданы или это не массив, возвращаем как есть
      if (!Array.isArray(items)) {
        return items
      }

      const translateItems = (menuItems: ContextMenuItem[]): ContextMenuItem[] => {
        return menuItems.map((item: ContextMenuItem) => {
          // Проверяем, что элемент является объектом (исключаем строки-разделители)
          // console.log('ITEM', item)
          if (typeof item === 'object' && item !== null) {
            
            // 1. Перевод основного текста
            if ('text' in item && typeof item.text === 'string') {
              const key = item.text.toLowerCase()
              
              if (translations[key]) {
                item.text = translations[key]
              }
            }

            // 2. Перевод всплывающих подсказок
            if ('title' in item && typeof item.title === 'string') {
              const key = item.title.toLowerCase()
              if (translations[key]) {
                item.title = translations[key]
              }
            }

            if (item.main?.text) {
              item.main = translateItems([item.main])[0]
            }

            // 3. Рекурсивный обход вложенных подменю (например, выбор типа)
            if ('items' in item && Array.isArray(item.items)) {
              item.items = translateItems(item.items)
            }
          }

          return item
        })
      }

      // Возвращаем измененный плоский массив элементов меню
      return translateItems(items)
    }
  },
})
</script>

<style lang="css" scoped>

  .CodeMirror cm-s-monokai {
    height: 100% !important;
    min-height: 100% !important;
    position: absolute !important;
  }

  .vue-codemirror {
    height: 100%;
    width: 100%;
    position: relative;
  }

  .customToolbar {
    background-color: #58595B;
    height: 48px;
    font-size: 20px;
    font-weight: 500;
  }

</style>

<style lang="stylus" scoped>
.rule
  border 1px solid #c1c163
  margin-bottom: 5px;
  padding: 5px;
.rule-item
  //border 1px solid red
  display flex
  justify-content stretch
  align-items baseline
  .field
    margin 0 3px
    outline: darkgray solid 1px;
    height: 30px;
    padding-left: 5px;
    line-height: 30px;
    background-color: white;
.v-btn.supersmall
  padding-top: 4px
  height: 24px
  width: 24px
  right: 5px
</style>
